<template>
  <el-form
    :model="pagesForm"
    :rules="rules"
    ref="pagesForm"
    label-width="12%"
    class="page-detail"
  >
    <el-form-item
      :label="generateCustomizeString('pageTitle')"
      prop="name"
    >
      <el-input v-model="pagesForm.name"></el-input>
    </el-form-item>
    <el-form-item
      :label="generateCustomizeString('pageSuffix')"
      prop="url_suffix"
      v-if="isEdit"
    >
      <el-input
        v-model="pagesForm.url_suffix"
        :disabled="delete_enable"
      ></el-input>
    </el-form-item>
    <el-form-item
      :label="generateCustomizeString('pageSuffix')"
      prop="url_suffix"
      v-else
    >
      <el-input
        v-model="pagesForm.url_suffix"
        onkeyup="value=value.replace(/\s/g,'-')"
      ></el-input>
      <div style="font-size: 12px; color: #606266;">
        {{generateCustomizeString('pageSuffixTip')}}
      </div>
    </el-form-item>
    <el-form-item
      :label="generateCustomizeString('pageUrl')"
      prop="url"
      v-if="isEdit"
    >
      <a :href="mobileUrl + '/storeWiki/' + pagesForm.url_suffix" target="_blank">
        <el-tag style="font-size: 14px;">{{mobileUrl + '/storeWiki/' + pagesForm.url_suffix}}</el-tag>
      </a>
    </el-form-item>
    <el-form-item
      :label="generateCustomizeString('sort')"
      prop="sort_by"
    >
      <el-input
        v-model="pagesForm.sort_by"
        type="number"
      ></el-input>
    </el-form-item>
    <el-form-item
      :label="generateCustomizeString('pageStatus')"
      prop="is_show"
    >
      <el-switch
        v-model="pagesForm.is_show"
        :active-text="generateCustomizeString('moduleReady')"
        :inactive-text="generateCustomizeString('moduleWaitForReview')"
      >
      </el-switch>
    </el-form-item>
    <el-form-item
      :label="generateCustomizeString('pageDetail')"
      prop="content"
    >
      <tinymce
        :height="400"
        v-model="pagesForm.content"
      ></tinymce>
    </el-form-item>
    <el-form-item>
      <el-button
        v-if="isEdit"
        type="primary"
        @click="submitForm('pagesForm')"
        plain
      >{{generateCustomizeString('update')}} </el-button>
      <el-button
        v-if="!isEdit"
        type="primary"
        @click="submitForm('pagesForm')"
      >{{generateCustomizeString('create')}}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import Tinymce from '@/components/Tinymce'
import request from '@/utils/request'

const defaultPages = {
  name: '',
  sort_by: 0,
  is_show: false,
  content: '',
  url_suffix: ''
}

export default {
  name: 'PageDetail',
  components: {
    Tinymce
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mobileUrl: this.$store.state.shop.shop_custom_host
        ? 'http://' + this.$store.state.shop.shop_custom_host
        : process.env.VUE_APP_MOBILE_URL + this.$store.state.shop.shop_domain_prefix,
      pagesForm: Object.assign({}, defaultPages),
      fetchLoding: false,
      delete_enable: true,
      rules: {
        url_suffix: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    generateCustomizeString,
    submitForm(formName) {
      if (this.isEdit) {
        this.updatePage()
      } else {
        this.createPage()
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    fetchPage() {
      if (this.fetchLoding) return
      this.fetchLoding = true

      request({
        url: 'page/' + this.$route.params.pageId,
        method: 'get'
      })
        .then(res => {
          if (res.status === 0) {
            for (const i in this.pagesForm) {
              this.pagesForm[i] = res.data[i]

              if (i === 'is_show') {
                this.pagesForm.is_show = res.data[i] === 1
              }

              if (i === 'delete_enable') {
                this.delete_enable = res.data[i] === 1
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.fetchLoding = false
        })
    },
    createPage() {
      if (!this.pagesForm.url_suffix) {
        this.$message({
          message: this.generateCustomizeString('pleaseEnter'),
          type: 'warning'
        })
        return
      }

      var data = this.pagesForm
      request({
        url: 'page',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('createdSuccessfully'),
              type: 'success'
            })

            this.$store.dispatch('delCurrentViews', {
              view: this.$route,
              $router: this.$router
            })
            this.$router.replace({ name: 'PcCmsPages' })
          } else {
            this.$message.error(this.generateCustomizeString('createFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('createFailed'))
        })
    },
    updatePage() {
      var data = this.pagesForm
      request({
        url: 'page/' + this.$route.params.pageId,
        method: 'put',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('createdSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('createFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('createFailed'))
        })
    }
  },
  // else {
  //   this.pagesForm = Object.assign({}, defaultPages)
  // }
  created() {
    if (location.host.includes('ieshop.co.nz')) {
      this.mobileUrl = 'https://m.ieshop.co.nz/m/' + this.$store.state.shop.shop_domain_prefix
    }
    if (this.isEdit || this.isView) {
      this.fetchPage()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.page-detail {
  padding: 50px 60px 0px 40px;
}
</style>
